import React, { MouseEventHandler } from 'react';
import { Button, Flex, Square } from '@grubhubprod/gh-cookbook-react';

interface AddPeopleToLocLoadMoreButtonProps {
  itemsToLoadMore: number;
  onClick: MouseEventHandler<HTMLButtonElement>;
}

export const AddGroupsToLocLoadMoreButton: React.FC<AddPeopleToLocLoadMoreButtonProps> =
  ({ itemsToLoadMore, onClick }) => {
    return (
      <Square
        as="li"
        inset="sm"
        borderBottom="1px solid"
        borderColor="lightLine"
      >
        <Flex alignItems="center" justifyContent="center" minHeight="72px">
          <Square inset="sm" width="100%">
            <Button
              data-testid="load-more-button"
              variant="secondary"
              type="button"
              buttonSize="large"
              block
              onClick={onClick}
            >
              <span>Load {itemsToLoadMore} more</span>
            </Button>
          </Square>
        </Flex>
      </Square>
    );
  };
